
/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AccountInformation,
  CurrentSessionDetails,
} from '../models';
import {
    AccountInformationFromJSON,
    AccountInformationToJSON,
    CurrentSessionDetailsFromJSON,
    CurrentSessionDetailsToJSON,
} from '../models';

/**
 * 
 */
export class CommonUserMeApi extends runtime.BaseAPI {

    /**
          */
    async getCurrentSessionDetailsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CurrentSessionDetails>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CurrentSessionDetails>({
            path: `/dashboard-client/api/user/current-session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CurrentSessionDetailsFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCurrentSessionDetails(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CurrentSessionDetails> {
        const response = await this.getCurrentSessionDetailsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getCurrentUserRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AccountInformation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AccountInformation>({
            path: `/dashboard-client/api/user/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AccountInformationFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCurrentUser(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AccountInformation> {
        const response = await this.getCurrentUserRaw(initOverrides);
        return response._data;
    }

}
